import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { DeleteAlertComponent, DialogData } from 'src/app/common/delete-alert/delete-alert.component';
import { SalesInvoiceService } from 'src/app/home/sales/sales-invoice/sales-invoice.service';
import { DataService } from 'src/app/service/data.service';

@Component({
  selector: 'app-selectserial-stockreq-noitem',
  templateUrl: './selectserial-stockreq-noitem.component.html',
  styleUrls: ['./selectserial-stockreq-noitem.component.scss']
})
export class SelectserialStockreqNoitemComponent implements OnInit {
  responseData: any;
  loadingTrue = false;
  searchTimeout: any;
  ic = '';
  item = {
    ina: '',
    ic: '',
    itemdisplayname: '',
    serialnumbers: [],
    reffield2: [],
    reffield3: [],
    reffield4: [],
    reffield5: [],
    reffield6: [],
    reffield7: [],
    reffield8: [],
    reffield9: [],
    reffield10: [],
  };
  itemData = {
    serialsetups: {
      reffield2: {
        required: '',
        caption: '',
        repeatable: ''
      },
      reffield3: {
        required: '',
        caption: '',
        repeatable: ''
      },
      reffield4: {
        required: '',
        caption: '',
        repeatable: ''
      },
      reffield5: {
        required: '',
        caption: '',
        repeatable: ''
      },
      reffield6: {
        required: '',
        caption: '',
        repeatable: ''
      },
      reffield7: {
        required: '',
        caption: '',
        repeatable: ''
      },
      reffield8: {
        required: '',
        caption: '',
        repeatable: ''
      },
      reffield9: {
        required: '',
        caption: '',
        repeatable: ''
      },
      reffield10: {
        required: '',
        caption: '',
        repeatable: ''
      }
    },
    serialstocks: {
      serialnumbers: [],
      reffield2: [],
      reffield3: [],
      reffield4: [],
      reffield5: [],
      reffield6: [],
      reffield7: [],
      reffield8: [],
      reffield9: [],
      reffield10: [],
    },
    totalstocks: '',
    salerate: ''
  };
  constructSerials = [];
  ina = '';
  xserial = {
    serialnumbers: '',
    reffield2: '',
    reffield3: '',
    reffield4: '',
    reffield5: '',
    reffield6: '',
    reffield7: '',
    reffield8: '',
    reffield9: '',
    reffield10: ''
  };
  serialnumbers = [];
  constructor(
    public dialogRef: MatDialogRef<SelectserialStockreqNoitemComponent>,
    @Inject(MAT_DIALOG_DATA) public xdata: DialogData,
    public data: DataService,
    public dialog: MatDialog,
    public invoiceService: SalesInvoiceService
  ) {
    this.responseData = this.xdata;
    this.ic = this.responseData.ic;
    this.constructSerials = this.responseData.constructSerials;
    this.ina = this.responseData.ina;
   }

  ngOnInit() {
    this.item = this.responseData.item;
    this.getData();
    console.log(this.invoiceService.constructSerials);
    console.log(this.serialnumbers);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  clearItemData(): void {
    this.itemData = {
      serialsetups: {
        reffield2: {
          required: '',
          caption: '',
          repeatable: ''
        },
        reffield3: {
          required: '',
          caption: '',
          repeatable: ''
        },
        reffield4: {
          required: '',
          caption: '',
          repeatable: ''
        },
        reffield5: {
          required: '',
          caption: '',
          repeatable: ''
        },
        reffield6: {
          required: '',
          caption: '',
          repeatable: ''
        },
        reffield7: {
          required: '',
          caption: '',
          repeatable: ''
        },
        reffield8: {
          required: '',
          caption: '',
          repeatable: ''
        },
        reffield9: {
          required: '',
          caption: '',
          repeatable: ''
        },
        reffield10: {
          required: '',
          caption: '',
          repeatable: ''
        }
      },
      serialstocks: {
        serialnumbers: [],
        reffield2: [],
        reffield3: [],
        reffield4: [],
        reffield5: [],
        reffield6: [],
        reffield7: [],
        reffield8: [],
        reffield9: [],
        reffield10: [],
      },
      totalstocks: '',
      salerate: ''
    };
  }

  getData(): void {
    this.loadingTrue = true;
    this.data.getData('item/' + this.ic + '/serialdetails').then((success) => {
      this.responseData = success;
      if (this.responseData.Status === true) {
        this.itemData = this.responseData.data;
      } else {
        this.clearItemData();
      }
      this.loadingTrue = false;
    }, (error) => { });
  }

  goNext(): void {
    this.itemData.serialstocks.serialnumbers = [];
    this.itemData.serialstocks.reffield2 = [];
    this.itemData.serialstocks.reffield3 = [];
    this.itemData.serialstocks.reffield4 = [];
    this.itemData.serialstocks.reffield5 = [];
    this.itemData.serialstocks.reffield6 = [];
    this.itemData.serialstocks.reffield7 = [];
    this.itemData.serialstocks.reffield8 = [];
    this.itemData.serialstocks.reffield9 = [];
    this.itemData.serialstocks.reffield10 = [];
    this.constructSerials.forEach((element) => {
      this.itemData.serialstocks.serialnumbers.push(element.serialnumbers);
      this.itemData.serialstocks.reffield2.push(element.reffield2);
      this.itemData.serialstocks.reffield3.push(element.reffield3);
      this.itemData.serialstocks.reffield4.push(element.reffield4);
      this.itemData.serialstocks.reffield5.push(element.reffield5);
      this.itemData.serialstocks.reffield6.push(element.reffield6);
      this.itemData.serialstocks.reffield7.push(element.reffield7);
      this.itemData.serialstocks.reffield8.push(element.reffield8);
      this.itemData.serialstocks.reffield9.push(element.reffield9);
      this.itemData.serialstocks.reffield10.push(element.reffield10);
    });
    this.dialogRef.close({
      itemData: this.itemData,
      construct: this.constructSerials
    });
  }

  checkDelete(el): void {
    const dialogRef = this.dialog.open(DeleteAlertComponent, {
      width: '350px',
      data: {
        msg: 'Are you sure you want to delete this Serial',
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.doDelete(el);
      }
    });
  }

  doDelete(el) {
    this.constructSerials.splice(el, 1);
  }

  clearxserial() {
    this.xserial = {
      serialnumbers: '',
      reffield2: '',
      reffield3: '',
      reffield4: '',
      reffield5: '',
      reffield6: '',
      reffield7: '',
      reffield8: '',
      reffield9: '',
      reffield10: ''
    };
  }

  addNewSerial() {
    let value = {};
    const assignValue = Object.assign(value, this.xserial);
    this.constructSerials.push(value);
    this.clearxserial();
  }
}
